<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">My Activity</div>
          </template>
        </es-header>
      </div>
      <div class="content is-paddingless">
        <es-loader v-if="loading"/>
        <div v-else>
          <es-exception
            v-if="!reports || !reports.length"
            exceptionMessage="No results were found."
            style="padding: 3rem; margin: 0"
          />
          <div v-else>
            <div class="activity-row" v-for="report in reports" :key="report.id">
                <div class="activity-row-container">
                  <div class="activity-element icon-column">
                    <font-awesome-icon
                      :icon="['fas', `${ reportIcons[report.format]}`]"
                      class="text-muted fa-xl"/>
                  </div>
                  <div class="activity-summary">
                    <div class="activity-element">
                      <strong>
                        {{ getReportType(report.reportId).name }}
                      </strong>
                      <span class="text-muted" v-if="!report.endDate">
                        report is generating. Click
                        <a @click="refresh()" @keypress.enter.prevent="refresh()" tabindex="0" role="button">
                          <font-awesome-icon :icon="['fas', 'sync-alt']" class="lg"/>
                        </a> to get the most current data.
                      </span>
                      <span class="text-muted" v-else>
                        report is ready to download
                      </span>
                    </div>
                    <a v-if="report.endDate"
                      class="activity-element"
                      :class="{ disabled: !hasDownloadPrivilege }"
                      download
                      :href="buildUrl(report)">
                        <font-awesome-icon :icon="['fal', 'arrow-circle-down']" size="lg"/>
                        Start download
                    </a>
                    <div v-else class="activity-element text-muted">
                      <font-awesome-icon :icon="['fal', 'spinner']" size="lg" class="icon-column"/>
                        Generating
                    </div>
                    <div class="activity-element text-muted">
                      <font-awesome-icon :icon="['fas', 'clock']" class="icon-column"/>
                        {{ (report.endDate || report.startDate) | formatDateMMDDYYYYHHMM }}
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import EsHeader from '@/components/EsHeader.vue';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';

// icons
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileExcel, faFilePdf, faSyncAlt, faClock,
} from '@fortawesome/pro-solid-svg-icons';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';

// mixins
import PermissionManager from '@/mixins/PermissionManager';

// utils
import axios from 'axios';

library.add(
  faFileExcel,
  faFilePdf,
  faSyncAlt,
  faClock,
  faSpinner,
);

export default {
  components: { EsHeader, EsException, EsLoader },
  mixins: [PermissionManager],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    reports: {
      type: Array,
      default: () => [],
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      reportIcons: {
        PDF: 'file-pdf',
        XLSX: 'file-excel',
      },
    };
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    buildUrl(report) {
      const reportType = this.getReportType(report.reportId);
      return `${axios.defaults.baseURL}personid/reports/${reportType.code}/${report.id}/download`;
    },
    getReportType(id) {
      return this.reportTypes.find(reportType => reportType.id === id);
    },
  },
  computed: {
    hasDownloadPrivilege() {
      return this.hasModule('PRSID:DWNLD:DOWNLOAD');
    },
  },
};
</script>

<style lang="sass" scoped>
  .text-muted
    color: #6c757d !important
  .activity-row
    border-top: 1px solid rgb(222, 226, 230)
    padding: .5rem 1rem
  .activity-row-container
    margin-top: 0.5em
    display: flex
  .icon-column
    margin-right: 0.85rem
  .activity-summary
    font-size: .85rem
    display: flex
    flex-direction: column
    align-items: flex-start
  .activity-element
    padding-top: 4px
    padding-bottom: 4px
    text-align: left
    .icon-column
      margin-right: 0.25rem
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
</style>
